/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Document
 */
export interface Document {
  /** documentId */
  documentId: string;

  /** documentType */
  documentType: string;

  /** documentRefId */
  documentRefId?: string;

  /** documentRefType */
  documentRefType?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate?: string;
}

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Добавление договора
 */
export interface AgreementRequest {
  /** Тип договора, определяется в системе источнике в зависимости от наличия УНК */
  type?: string;

  /**
   * Дата договора
   * @format date
   * @example 2022-05-08
   */
  date?: string;

  /** Номер договора */
  number?: string;

  /**
   * Признак "Без суммы"
   * @example false
   */
  isWithoutSum?: boolean;

  /** Сумма договора */
  sum?: number;

  /**
   * Буквенный код валюты ISO
   * @example RUB
   */
  currency?: string;

  /**
   * Цифровой код валюты ISO
   * @example 643
   */
  currencyCode?: string;

  /** УНК присвоенный системой ТБСВК */
  unk?: string;

  /**
   * Дата постановки договора на учёт
   * @format date
   * @example 2017-05-08
   */
  bankRegDate?: string;

  /**
   * Дата завершения обязательств
   * @format date
   * @example 2025-05-08
   */
  closeDate?: string;

  /**
   * Дата снятия договора с учёта
   * @format date
   * @example 2025-05-08
   */
  bankCloseDate?: string;

  /** Сумма договора не превышает эквивалент 600 000 рублей */
  isContractLimit?: boolean;

  /** Уникальный идентификатор клиента банка */
  clientId?: string;

  /** Id контрагента клиента из системы источник */
  contractorIdList?: string[];

  /** Список Контрагентов ДБО */
  msContractor?: SaveMsContractor[];
}

/**
 * Реквизиты контрагента (МС Контрагенты)
 */
export interface Requisite {
  /**
   * Тип реквизитов
   * @format int32
   */
  type?: number;

  /**
   * Идентификатор реквизитов из МС Контрагенты
   * @format uuid
   */
  id?: string;
}

/**
 * Список Контрагентов ДБО
 */
export interface SaveMsContractor {
  /**
   * НДБО-идентификатор нерезидента
   * @format uuid
   */
  id?: string;

  /** Наименование нерезидента */
  name?: string;

  /** Признак аффилированного лица */
  isAffiliated?: boolean;

  /**
   * Идентификатор страны Контрагента
   * @format uuid
   * @example 5e86fee1-750e-11ec-b8c4-97ca1919835d
   */
  countryId?: string;

  /**
   * Код страны Контрагента
   * @example 426
   */
  countryCodeIso?: string;

  /** Реквизиты контрагента (МС Контрагенты) */
  requisite?: Requisite[];

  /** Дополнительный код организации */
  orgCode?: string;
}

/**
 * Добавление договора
 */
export interface SaveAgreementResponse {
  /**
   * Идентификатор договора
   * @format uuid
   */
  agreementID?: string;
}

/**
 * Обновление договора
 */
export interface AgreementRenovation {
  /** Тип договора, определяется в системе источнике в зависимости от наличия УНК */
  type?: string;

  /**
   * Дата договора
   * @format date
   * @example 2022-05-08
   */
  date?: string;

  /** Номер договора */
  number?: string;

  /**
   * Признак "Без суммы"
   * @example false
   */
  isWithoutSum?: boolean;

  /** Сумма договора */
  sum?: number;

  /**
   * Буквенный код валюты ISO
   * @example RUB
   */
  currency?: string;

  /**
   * Цифровой код валюты ISO
   * @example 643
   */
  currencyCode?: string;

  /** УНК присвоенный системой ТБСВК */
  unk?: string;

  /**
   * Дата постановки договора на учёт
   * @format date
   * @example 2017-05-08
   */
  bankRegDate?: string;

  /**
   * Дата завершения обязательств
   * @format date
   * @example 2025-05-08
   */
  closeDate?: string;

  /**
   * Дата снятия договора с учёта
   * @format date
   * @example 2025-05-08
   */
  bankCloseDate?: string;

  /** Сумма договора не превышает эквивалент 600 000 рублей */
  isContractLimit?: boolean;

  /** Список Контрагентов ДБО */
  msContractor?: SaveMsContractor[];

  /** Вложения к документу ЗоСсУ */
  attachments?: AttachmentRequest[];
}

/**
 * Информация о вложении
 */
export interface AttachmentRequest {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /** Имя файла */
  fileName?: string;

  /** Содержимое файла с кодировкой в формате base64 */
  encodedString?: string;
}

/**
 * Получение списка договоров по клиенту версия 2
 */
export interface AgreementListV2 {
  /** Тип договора, определяется в системе источнике в зависимости от наличия УНК */
  type?: string;

  /**
   * Дата договора
   * @format date
   * @example 2022-05-08
   */
  date?: string;

  /** Номер договора */
  number?: string;

  /**
   * Признак "Без суммы"
   * @example false
   */
  isWithoutSum?: boolean;

  /** Сумма договора */
  sum?: number;

  /**
   * Буквенный код валюты ISO
   * @example RUB
   */
  currency?: string;

  /**
   * Цифровой код валюты ISO
   * @example 643
   */
  currencyCode?: string;

  /** УНК присвоенный системой ТБСВК */
  unk?: string;

  /**
   * Дата постановки договора на учёт
   * @format date
   * @example 2017-05-08
   */
  bankRegDate?: string;

  /**
   * Дата завершения обязательств
   * @format date
   * @example 2025-05-08
   */
  closeDate?: string;

  /**
   * Дата снятия договора с учёта
   * @format date
   * @example 2025-05-08
   */
  bankCloseDate?: string;

  /** Сумма договора не превышает эквивалент 600 000 рублей */
  isContractLimit?: boolean;

  /**
   * Идентификатор договора
   * @format uuid
   */
  id: string;

  /** Уникальный идентификатор клиента банка */
  clientId: string;

  /** Статус документа */
  state?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate: string;

  /** Id контрагента клиента из системы источник */
  contractorIdList?: string[];

  /** Массив идентификаторов Контрагентов (МС Контрагенты) */
  msContractorIdList?: string[];

  /** ВБК договора ВЭД */
  vbk?: VbkCommonFiles;

  /** Список контрагентов */
  contractor?: ContractorV2[];
}

/**
 * Страна нерезидента (контрагента)
 */
export interface ContractorCountry {
  /**
   * Идентификатор страны
   * @format uuid
   */
  id?: string;

  /** Код страны нерезидента */
  code?: string;

  /** Наименование страны */
  name?: string;

  /** Международное наименование страны */
  nameLat?: string;

  /** Двухбуквенный код страны контрагента */
  twoLetterCode?: string;
}

/**
 * Контрагент по договору ВЭД c Дополнительным кодом организации
 */
export interface ContractorV2 {
  /**
   * НДБО-идентификатор нерезидента
   * @format uuid
   */
  id?: string;

  /** Наименование нерезидента */
  name?: string;

  /** Признак аффилированного лица */
  isAffiliated?: boolean;

  /** Страна нерезидента (контрагента) */
  country?: ContractorCountry;

  /** Дополнительный код организации */
  orgCode?: string;
}

/**
 * ВБК договора ВЭД
 */
export interface VbkCommonFiles {
  /**
   * Идентификатор pdf-файла ВБК
   * @format uuid
   */
  pdfFileId?: string;

  /**
   * Идентификатор xml-файла ВБК
   * @format uuid
   */
  xmlFileId?: string;

  /**
   * Дата последнего изменения по запросу ВБК
   * @format date-time
   */
  lastUpdate: string;
}

/**
 * Получение договоров по клиенту
 */
export interface AgreementExt {
  /** Тип договора, определяется в системе источнике в зависимости от наличия УНК */
  type?: string;

  /**
   * Дата договора
   * @format date
   * @example 2022-05-08
   */
  date?: string;

  /** Номер договора */
  number?: string;

  /**
   * Признак "Без суммы"
   * @example false
   */
  isWithoutSum?: boolean;

  /** Сумма договора */
  sum?: number;

  /**
   * Буквенный код валюты ISO
   * @example RUB
   */
  currency?: string;

  /**
   * Цифровой код валюты ISO
   * @example 643
   */
  currencyCode?: string;

  /** УНК присвоенный системой ТБСВК */
  unk?: string;

  /**
   * Дата постановки договора на учёт
   * @format date
   * @example 2017-05-08
   */
  bankRegDate?: string;

  /**
   * Дата завершения обязательств
   * @format date
   * @example 2025-05-08
   */
  closeDate?: string;

  /**
   * Дата снятия договора с учёта
   * @format date
   * @example 2025-05-08
   */
  bankCloseDate?: string;

  /** Сумма договора не превышает эквивалент 600 000 рублей */
  isContractLimit?: boolean;

  /**
   * Идентификатор договора
   * @format uuid
   */
  id: string;

  /** Уникальный идентификатор клиента банка */
  clientId: string;

  /** Статус документа */
  state?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate: string;

  /** ВБК договора ВЭД */
  vbk?: VbkList;

  /** Id контрагента клиента из системы источник */
  contractorIdList?: string[];

  /** Массив идентификаторов Контрагентов (МС Контрагенты) */
  msContractorIdList?: string[];

  /** Символ валюты договора */
  currencySymbol?: string;

  /** Список контрагентов */
  contractor?: ContractorV2[];

  /** Код филиала, в котором обслуживается клиент */
  branchCode?: string;

  /** Краткое наименование клиента */
  clientName?: string;

  /** ИНН клиента */
  clientInn?: string;
}

/**
 * Получение списка договоров ВЭД по JWT-токену Клиента
 */
export interface AgreementExtPlus {
  /** Признак наличия следующих страниц данных */
  hasMore: boolean;

  /**
   * Количество договоров ВЭД
   * @format int32
   */
  contractAmount: number;

  /**
   * Количество договоров ВЭД в выборке без учёта пагинации
   * @format int32
   */
  totalItems?: number;

  /** Список договоров по клиенту */
  contract?: AgreementExt[];
}

/**
 * ВБК договора ВЭД
 */
export interface VbkDetail {
  /**
   * Идентификатор pdf-файла ВБК
   * @format uuid
   */
  pdfFileId?: string;

  /**
   * Идентификатор xml-файла ВБК
   * @format uuid
   */
  xmlFileId?: string;

  /**
   * Дата последнего изменения по запросу ВБК
   * @format date-time
   */
  lastUpdate: string;

  /**
   * Идентификатор запроса ВБК
   * @format uuid
   */
  id: string;

  /** Статус запроса ВБК */
  state: string;

  /**
   * Идентификатор договора ВЭД
   * @format uuid
   */
  agreementId: string;

  /** УНК договора ВЭД */
  unk: string;

  /** Тип запроса, отправляемого в ТБС ВК */
  vbkType: string;

  /** Внешний АБС-идентификатор Клиента (для документов МС) */
  clientExtId: string;

  /**
   * Внутренний НДБО-идентификатор Клиента (для документов НДБО)
   * @format int32
   */
  dboClientId: number;
}

/**
 * ВБК договора ВЭД
 */
export interface VbkList {
  /**
   * Идентификатор pdf-файла ВБК
   * @format uuid
   */
  pdfFileId?: string;

  /**
   * Идентификатор xml-файла ВБК
   * @format uuid
   */
  xmlFileId?: string;

  /**
   * Дата последнего изменения по запросу ВБК
   * @format date-time
   */
  lastUpdate: string;

  /**
   * Идентификатор запроса ВБК
   * @format uuid
   */
  id: string;

  /** Статус запроса ВБК */
  state: string;

  /**
   * Идентификатор договора ВЭД
   * @format uuid
   */
  agreementId: string;

  /** УНК договора ВЭД */
  unk: string;

  /** Тип запроса, отправляемого в ТБС ВК */
  vbkType: string;

  /** Внешний АБС-идентификатор Клиента (для документов МС) */
  clientExtId: string;

  /**
   * Внутренний НДБО-идентификатор Клиента (для документов НДБО)
   * @format int32
   */
  dboClientId: number;

  /**
   * Дата и время создания запроса ВБК
   * @format date-time
   */
  createDate: string;

  /**
   * Дата и время создания запроса ВБК
   * @format date-time
   */
  uploadDate: string;

  /** Признак способа получения ВБК */
  isManual: boolean;
}

/**
 * Получение списка ВБК
 */
export interface VbkListResponse {
  /** Наличие следующих страниц */
  hasMore?: boolean;

  /**
   * Количество запросов ВБК в выборке без учёта пагинации
   * @format int32
   */
  totalItems?: number;

  /**
   * Количество запросов ВБК в текущей выборке
   * @format int32
   */
  selectItems?: number;

  /** Список запросов ВБК */
  items?: VbkList[];
}

/**
 * Получение списка договоров ВЭД валютным контроллером
 */
export interface AgreementControlList {
  /** Наличие следующих страниц */
  hasMore?: boolean;

  /**
   * Количество запросов ВБК в выборке без учёта пагинации
   * @format int32
   */
  totalItems?: number;

  /**
   * Количество запросов ВБК в текущей выборке
   * @format int32
   */
  selectItems?: number;

  /** Список договоров по клиенту */
  items?: AgreementExt[];
}

/**
 * Получение договоров по клиенту для валютного контролера
 */
export interface AgreementDetailExtControl {
  /** Тип договора, определяется в системе источнике в зависимости от наличия УНК */
  type?: string;

  /**
   * Дата договора
   * @format date
   * @example 2022-05-08
   */
  date?: string;

  /** Номер договора */
  number?: string;

  /**
   * Признак "Без суммы"
   * @example false
   */
  isWithoutSum?: boolean;

  /** Сумма договора */
  sum?: number;

  /**
   * Буквенный код валюты ISO
   * @example RUB
   */
  currency?: string;

  /**
   * Цифровой код валюты ISO
   * @example 643
   */
  currencyCode?: string;

  /** УНК присвоенный системой ТБСВК */
  unk?: string;

  /**
   * Дата постановки договора на учёт
   * @format date
   * @example 2017-05-08
   */
  bankRegDate?: string;

  /**
   * Дата завершения обязательств
   * @format date
   * @example 2025-05-08
   */
  closeDate?: string;

  /**
   * Дата снятия договора с учёта
   * @format date
   * @example 2025-05-08
   */
  bankCloseDate?: string;

  /** Сумма договора не превышает эквивалент 600 000 рублей */
  isContractLimit?: boolean;

  /**
   * Идентификатор договора
   * @format uuid
   */
  id: string;

  /** Уникальный идентификатор клиента банка */
  clientId: string;

  /** Статус документа */
  state?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate: string;

  /** ВБК договора ВЭД */
  vbk?: VbkDetail;

  /** Id контрагента клиента из системы источник */
  contractorIdList?: string[];

  /** Массив идентификаторов Контрагентов (МС Контрагенты) */
  msContractorIdList?: string[];

  /** Символ валюты договора */
  currencySymbol?: string;

  /** Список контрагентов */
  contractor?: ContractorV2[];

  /** Код филиала, в котором обслуживается клиент */
  branchCode?: string;

  /** Наименование Банка Клиента, в рамках которого обсуживается договор */
  authBankName?: string;

  /** Краткое наименование клиента */
  clientName?: string;

  /** ИНН клиента */
  clientInn?: string;

  /** КПП клиента */
  clientKpp?: string;
}

/**
 * Вложение документа
 */
export interface DocumentAttachment {
  /** Id файла */
  fileExtId?: string;

  /** Наименование файла */
  fileName?: string;

  /** Категория */
  category?: string;
}

/**
 * Бенефициар документа
 */
export interface DocumentContractor {
  /**
   * Идентификатор контрагента
   * @format uuid
   */
  id?: string;

  /** Название контрагента */
  name?: string;

  /** Страна нерезидента (контрагента) */
  country?: ContractorCountry;
}

/**
 * Получение договоров по клиенту
 */
export interface AgreementList {
  /** Тип договора, определяется в системе источнике в зависимости от наличия УНК */
  type?: string;

  /**
   * Дата договора
   * @format date
   * @example 2022-05-08
   */
  date?: string;

  /** Номер договора */
  number?: string;

  /**
   * Признак "Без суммы"
   * @example false
   */
  isWithoutSum?: boolean;

  /** Сумма договора */
  sum?: number;

  /**
   * Буквенный код валюты ISO
   * @example RUB
   */
  currency?: string;

  /**
   * Цифровой код валюты ISO
   * @example 643
   */
  currencyCode?: string;

  /** УНК присвоенный системой ТБСВК */
  unk?: string;

  /**
   * Дата постановки договора на учёт
   * @format date
   * @example 2017-05-08
   */
  bankRegDate?: string;

  /**
   * Дата завершения обязательств
   * @format date
   * @example 2025-05-08
   */
  closeDate?: string;

  /**
   * Дата снятия договора с учёта
   * @format date
   * @example 2025-05-08
   */
  bankCloseDate?: string;

  /** Сумма договора не превышает эквивалент 600 000 рублей */
  isContractLimit?: boolean;

  /**
   * Идентификатор договора
   * @format uuid
   */
  id: string;

  /** Уникальный идентификатор клиента банка */
  clientId: string;

  /** Статус документа */
  state?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate: string;

  /** Id контрагента клиента из системы источник */
  contractorIdList?: string[];

  /** Массив идентификаторов Контрагентов (МС Контрагенты) */
  msContractorIdList?: string[];

  /** ВБК договора ВЭД */
  vbk?: VbkCommonFiles;
}

/**
 * Получение договоров по клиенту
 */
export interface Agreement {
  /** Тип договора, определяется в системе источнике в зависимости от наличия УНК */
  type?: string;

  /**
   * Дата договора
   * @format date
   * @example 2022-05-08
   */
  date?: string;

  /** Номер договора */
  number?: string;

  /**
   * Признак "Без суммы"
   * @example false
   */
  isWithoutSum?: boolean;

  /** Сумма договора */
  sum?: number;

  /**
   * Буквенный код валюты ISO
   * @example RUB
   */
  currency?: string;

  /**
   * Цифровой код валюты ISO
   * @example 643
   */
  currencyCode?: string;

  /** УНК присвоенный системой ТБСВК */
  unk?: string;

  /**
   * Дата постановки договора на учёт
   * @format date
   * @example 2017-05-08
   */
  bankRegDate?: string;

  /**
   * Дата завершения обязательств
   * @format date
   * @example 2025-05-08
   */
  closeDate?: string;

  /**
   * Дата снятия договора с учёта
   * @format date
   * @example 2025-05-08
   */
  bankCloseDate?: string;

  /** Сумма договора не превышает эквивалент 600 000 рублей */
  isContractLimit?: boolean;

  /**
   * Идентификатор договора
   * @format uuid
   */
  id: string;

  /** Уникальный идентификатор клиента банка */
  clientId: string;

  /** Статус документа */
  state?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate: string;

  /** ВБК договора ВЭД */
  vbk?: VbkDetail;

  /** Id контрагента клиента из системы источник */
  contractorIdList?: string[];

  /** Массив идентификаторов Контрагентов (МС Контрагенты) */
  msContractorIdList?: string[];
}

/**
 * ВБК договора ВЭД
 */
export interface Vbk {
  /**
   * Идентификатор запроса ВБК
   * @format uuid
   */
  id: string;

  /** Статус запроса ВБК */
  state: string;

  /**
   * Идентификатор договора ВЭД
   * @format uuid
   */
  agreementId: string;

  /** УНК договора ВЭД */
  unk: string;

  /** Тип запроса, отправляемого в ТБС ВК */
  vbkType: string;

  /**
   * Идентификатор pdf-файла ВБК
   * @format uuid
   */
  fileId?: string;

  /** Тип файла ВБК XML и PDF */
  fileType?: string;

  /** Внешний АБС-идентификатор Клиента (для документов МС) */
  clientExtId: string;

  /**
   * Дата последнего изменения по запросу ВБК
   * @format date-time
   */
  lastUpdate: string;
}

/**
 * Получение договора по клиенту
 */
export interface AgreementDetail {
  /** Тип договора, определяется в системе источнике в зависимости от наличия УНК */
  type?: string;

  /**
   * Дата договора
   * @format date
   * @example 2022-05-08
   */
  date?: string;

  /** Номер договора */
  number?: string;

  /**
   * Признак "Без суммы"
   * @example false
   */
  isWithoutSum?: boolean;

  /** Сумма договора */
  sum?: number;

  /**
   * Буквенный код валюты ISO
   * @example RUB
   */
  currency?: string;

  /**
   * Цифровой код валюты ISO
   * @example 643
   */
  currencyCode?: string;

  /** УНК присвоенный системой ТБСВК */
  unk?: string;

  /**
   * Дата постановки договора на учёт
   * @format date
   * @example 2017-05-08
   */
  bankRegDate?: string;

  /**
   * Дата завершения обязательств
   * @format date
   * @example 2025-05-08
   */
  closeDate?: string;

  /**
   * Дата снятия договора с учёта
   * @format date
   * @example 2025-05-08
   */
  bankCloseDate?: string;

  /** Сумма договора не превышает эквивалент 600 000 рублей */
  isContractLimit?: boolean;

  /**
   * Идентификатор договора
   * @format uuid
   */
  id: string;

  /** Уникальный идентификатор клиента банка */
  clientId: string;

  /** Статус документа */
  state?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate: string;

  /** ВБК договора ВЭД */
  vbk?: VbkDetail;

  /** Id контрагента клиента из системы источник */
  contractorIdList?: string[];

  /** Массив идентификаторов Контрагентов (МС Контрагенты) */
  msContractorIdList?: string[];

  /** Символ валюты договора */
  currencySymbol?: string;

  /** Список контрагентов */
  contractor?: ContractorV2[];

  /** Контрагенты валютных платежных поручений по договору */
  documentContractors?: DocumentContractor[];

  /** Вложения документов по договору */
  documentAttachments?: DocumentAttachment[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис currency-contract-dossier
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://127.0.0.1:8080
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Досье валютных договоров <info@rshbintech.ru> (http://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=105056884)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Документы
     * @name SaveDocumentLink
     * @summary Сохранение ссылки документа
     * @request POST:/api/currency/v1/internal/links/save_list
     */
    saveDocumentLink: (data: Document[], params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/currency/v1/internal/links/save_list`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Документы
     * @name GetDocumentLinks
     * @summary Получение ссылок связанных документов
     * @request POST:/api/currency/v1/internal/links/list
     */
    getDocumentLinks: (data: Document[], params: RequestParams = {}) =>
      this.request<Document, ErrorMessage>({
        path: `/api/currency/v1/internal/links/list`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Документы
     * @name DeleteDocumentLinks
     * @summary Удаление ссылок связанных документов
     * @request POST:/api/currency/v1/internal/links/delete
     */
    deleteDocumentLinks: (data: Document[], params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/currency/v1/internal/links/delete`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name ImportAgreement
     * @summary Импорт договоров ВЭД из xml-файла ТБСВК
     * @request POST:/api/currency/v1/internal/file/import
     * @secure
     */
    importAgreement: (data: { file: File }, params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/currency/v1/internal/file/import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name ImportZipAgreement
     * @summary Импорт договоров ВЭД из zip-файла c xml-файлами ТБСВК
     * @request POST:/api/currency/v1/internal/file/import-zip
     * @secure
     */
    importZipAgreement: (data: { file: File }, params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/currency/v1/internal/file/import-zip`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name ImportCsvAgreement
     * @summary Импорт договоров ВЭД из csv-файла
     * @request POST:/api/currency/v1/internal/file/import-csv
     * @secure
     */
    importCsvAgreement: (data: { file: File }, params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/currency/v1/internal/file/import-csv`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name SaveAgreement
     * @summary Добавление договора
     * @request POST:/api/currency/v1/internal/agreement/save
     */
    saveAgreement: (data: AgreementRequest, params: RequestParams = {}) =>
      this.request<SaveAgreementResponse, ErrorMessage>({
        path: `/api/currency/v1/internal/agreement/save`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Документы
     * @name GetDocumentLinksExt
     * @summary Получение ссылок связанных документов по JWT-токену Клиента
     * @request POST:/api/currency/v1/external/links/list
     * @secure
     */
    getDocumentLinksExt: (data: Document[], params: RequestParams = {}) =>
      this.request<Document[], ErrorMessage>({
        path: `/api/currency/v1/external/links/list`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name SaveAgreementExt
     * @summary Добавление договора по JWT-token
     * @request POST:/api/currency/v1/external/agreement/save
     * @secure
     */
    saveAgreementExt: (data: AgreementRequest, params: RequestParams = {}) =>
      this.request<SaveAgreementResponse, ErrorMessage>({
        path: `/api/currency/v1/external/agreement/save`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name RenovationAgreement
     * @summary Редактирование договора ВЭД
     * @request PATCH:/api/currency/v1/internal/agreement/update
     */
    renovationAgreement: (
      query: { agreementId: string },
      data: AgreementRenovation,
      params: RequestParams = {}
    ) =>
      this.request<SaveAgreementResponse, ErrorMessage>({
        path: `/api/currency/v1/internal/agreement/update`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name UpdateAgreement
     * @summary Редактирование договора ВЭД по JWT-token
     * @request PATCH:/api/currency/v1/external/agreement/update
     * @secure
     */
    updateAgreement: (
      query: { agreementId: string },
      data: AgreementRenovation,
      params: RequestParams = {}
    ) =>
      this.request<SaveAgreementResponse, ErrorMessage>({
        path: `/api/currency/v1/external/agreement/update`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name AgreementInfoClient2
     * @summary Получение списка договоров по клиенту версия 2
     * @request GET:/api/currency/v2/internal/agreement/list
     */
    agreementInfoClient2: (
      query: { sort?: string; clientId: string; isUNK?: boolean; unk?: string },
      params: RequestParams = {}
    ) =>
      this.request<AgreementListV2[], ErrorMessage>({
        path: `/api/currency/v2/internal/agreement/list`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name AgreementInfo2
     * @summary Получение списка договоров ВЭД по JWT-токену Клиента версия 2
     * @request GET:/api/currency/v2/external/agreement/list
     * @secure
     */
    agreementInfo2: (
      query?: {
        isUNK?: boolean;
        state?: string;
        beginDate?: string;
        endDate?: string;
        unk?: string;
        fullHouse?: string;
        count?: number;
        position?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<AgreementExtPlus, ErrorMessage>({
        path: `/api/currency/v2/external/agreement/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ВБК.АРМ
     * @name GetVbkControlList
     * @summary Получение списка запросов ВБК
     * @request GET:/api/currency/v1/internal/control/vbk
     * @secure
     */
    getVbkControlList: (
      query?: {
        position?: number;
        count?: number;
        beginDate?: string;
        endDate?: string;
        state?: string[];
        unk?: string;
        isManual?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<VbkListResponse, ErrorMessage>({
        path: `/api/currency/v1/internal/control/vbk`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры.АРМ
     * @name GetAgreementControlList
     * @summary Получение списка договоров
     * @request GET:/api/currency/v1/internal/control/agreement
     * @secure
     */
    getAgreementControlList: (
      query?: {
        position?: number;
        count?: number;
        clientInfo?: string;
        branchInfo?: string;
        unk?: string;
        typeCode?: number;
        number?: string;
        signDate?: string;
        bankRegDate?: string;
        bankCloseDate?: string;
        closeDate?: string;
        sum?: string;
        isWithoutSum?: boolean;
        currencyId?: string;
        isVbk?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<AgreementControlList, ErrorMessage>({
        path: `/api/currency/v1/internal/control/agreement`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры.АРМ
     * @name GetAgreementControl
     * @summary Получение деталей договора
     * @request GET:/api/currency/v1/internal/control/agreement/details/{uuid}
     * @secure
     */
    getAgreementControl: (uuid: string, params: RequestParams = {}) =>
      this.request<AgreementDetailExtControl, ErrorMessage>({
        path: `/api/currency/v1/internal/control/agreement/details/${uuid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name AgreementInfoClient
     * @summary Получение списка договоров по клиенту
     * @request GET:/api/currency/v1/internal/agreement/list
     */
    agreementInfoClient: (
      query: { clientId: string; isUNK?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<AgreementList[], ErrorMessage>({
        path: `/api/currency/v1/internal/agreement/list`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name DetailsAgreement
     * @summary Получение деталей договора
     * @request GET:/api/currency/v1/internal/agreement/details/{uuid}
     */
    detailsAgreement: (
      uuid: string,
      query: { clientId: string },
      params: RequestParams = {}
    ) =>
      this.request<Agreement[], ErrorMessage>({
        path: `/api/currency/v1/internal/agreement/details/${uuid}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name VbkAgreement
     * @summary Получение ВБК по договору по JWT-token
     * @request GET:/api/currency/v1/external/agreement/vbk/{id}
     * @secure
     */
    vbkAgreement: (
      id: string,
      query?: { type?: string },
      params: RequestParams = {}
    ) =>
      this.request<Vbk[], ErrorMessage>({
        path: `/api/currency/v1/external/agreement/vbk/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name AgreementInfo
     * @summary Получение списка договоров по клиенту по JWT-token
     * @request GET:/api/currency/v1/external/agreement/list
     * @secure
     */
    agreementInfo: (query?: { isUNK?: boolean }, params: RequestParams = {}) =>
      this.request<Agreement[], ErrorMessage>({
        path: `/api/currency/v1/external/agreement/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Договоры
     * @name DetailsAgreementExt
     * @summary Получение деталей договора по JWT-token
     * @request GET:/api/currency/v1/external/agreement/details/{uuid}
     * @secure
     */
    detailsAgreementExt: (uuid: string, params: RequestParams = {}) =>
      this.request<AgreementDetail, ErrorMessage>({
        path: `/api/currency/v1/external/agreement/details/${uuid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
